import { isEqual, merge } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { components, getServiceComponent, settingsSiteUser } from '@/utils'

import render from './render'

export default function(options) {
  return {
    mixins: [ settingsSiteUser(options) ],

    data() {
      return {
        settingsComponentCache: Object.create(null)
      }
    },

    watch: {
      schema: {
        handler() {
          if (this.settingsComponentCache) {
            this.settingsComponentCache = Object.create(null)
          }
        },
        deep: true
      }
    },

    computed: {
      bodyParams() {
        let component = components['expansion-panels']
        if (this.viewport.size.width > 1024) {
          component = components.card
        }

        return {
          component,
          props: {
            flat: true,
            overflow: true,
            outline: true,
            rounded: true
          }
        }
      }
    },

    methods: {
      getComponent(path) {
        const componentName = path.split('.').join('/')
        const pathToComponent = [ options.serviceName, componentName ].join('/')

        return getServiceComponent(pathToComponent)
      },
      getComponentOptions(path) {
        const result = merge({
          ...options,
          path,
          keys: this.keys,
          settings: this.settings,
          defaults: this.defaults,
          permission: this.keys[path],
          loading: this.loading
        })

        return result
      },
      getComponentDefinition(path) {
        if (options.serviceName === Services.settingsSite) {
          if (!this.settingsComponentCache) {
            this.settingsComponentCache = Object.create(null)
          }

          let componentDefinition = this.settingsComponentCache[path]
          if (!componentDefinition) {
            const componentFunction = this.getComponent(path)
            const componentOptions = this.getComponentOptions(path)
            if (componentFunction) {
              componentDefinition = componentFunction(componentOptions)
              this.settingsComponentCache[path] = componentDefinition
            }
          }

          return componentDefinition
        } else {
          const componentFunction = this.getComponent(path)
          const componentOptions = this.getComponentOptions(path)
          if (componentFunction) {
            return componentFunction(componentOptions)
          }
        }
      },

      inputEventHandler(event, path) {
        const settingAsString = JSON.stringify(this.settings[path])
        const eventAsString = JSON.stringify(event)
        if (!isEqual(settingAsString, eventAsString)) {
          this.updateSetting(path, event)
        }
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
